module.exports = __webpack_public_path__ + "static/media/importIcon.9e5854b0.webp";